export default "__VITE_ASSET__Cm6xe1Ir__"